import { matchesNestedKeyword } from '../../shared/utils/keyword-filter';
import { JstDate, serverTime } from '../../core/time/business-time';
import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { PageTitleService } from '../../core/services/page-title.service';
import { AuthStateService } from '../../core/services/auth-state.service';
import { StudioService } from '../../core/services/studio.service';
import { StudioSelectionService } from '../../core/services/studio-selection.service';
import { PagerComponent } from '../../shared/components/pager.component';
import { isWithinJstDateRange } from '../../shared/utils/jst-date';

const SESSION_KEY = 'expelled_select_studio_id';

// 旧版 expelled.js:35-36 の初期値。除名日は 2015-09-01 〜 当日(JST)
const DEFAULT_DATE_FROM = '2015-09-01';
const JST_OFFSET_MILLISECONDS = 9 * 60 * 60 * 1000;
function todayJstString(): string {
  return new JstDate(serverTime.now() + JST_OFFSET_MILLISECONDS).toISOString().slice(0, 10);
}

@Component({
    selector: 'app-expelled-list',
    imports: [FormsModule, DatePipe, PagerComponent],
    template: `
<div class="animated fadeIn container-fluid">
  <div class="card">
    <div class="card-header">
      <span><i class="fa s-icon-list"></i> 一覧 <span>(全 {{ filteredItems.length }} 件)</span></span>
    </div>
    <div class="card-body">
      <form novalidate>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-form-label" for="studio_name">店舗</label>
                <!-- 旧版 expelled.html:16 ng-disabled="disableSelect"：会員取得中は店舗を変更できない -->
                <select class="form-control" id="studio_name" [(ngModel)]="selectedStudio"
                  name="studio_name" (ngModelChange)="onStudioChange()" [disabled]="searching">
                  <option [ngValue]="null">-- 選択してください --</option>
                  @for (studio of studios; track studio.id) {
                    <option [ngValue]="studio">{{ studio.name }}</option>
                  }
                </select>
              </div>
            </div>
          </div>
          @if (selectedStudio) {
            <div class="col-md-4">
              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label" for="datePickerFrom">除名日</label>
                  <div class="bisected-input-wrap">
                    <div class="bisected-input">
                      <input id="datePickerFrom" name="date_from" type="date" [(ngModel)]="dateFrom" (ngModelChange)="pageIndex = 0" class="form-control">
                    </div>
                    <div><span>&nbsp;~&nbsp;</span></div>
                    <div class="bisected-input">
                      <input id="datePickerTo" name="date_to" type="date" [(ngModel)]="dateTo" (ngModelChange)="pageIndex = 0" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
        @if (selectedStudio) {
          <div class="row" style="align-items: flex-end;">
            <div class="col-md-8">
              <div class="form-group row">
                <div class="col-md-12">
                  <label class="col-form-label" for="keyword">キーワード検索</label>
                  <input id="keyword" name="keyword" type="text" [(ngModel)]="keyword" (ngModelChange)="pageIndex = 0"
                    class="form-control" placeholder="除名理由など">
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group row">
                <div class="col-md-12">
                  <button class="btn btn-warning text-white" type="button" (click)="clearFilter()">
                    <i class="fa s-icon-backspace"></i>&nbsp;条件クリア
                  </button>
                </div>
              </div>
            </div>
          </div>
        }
      </form>
      <hr>
    </div>
    <div class="card-body">
      <div class="form-group row">
        <div class="col-md-12">
          @if (userPermission <= 1 && selectedStudio) {
            <button class="btn btn-success" type="button" (click)="openDownloadModal()">
              <div class="file_format_icon dl">
                <div>
                  <span title="csv"></span>
                  <span class="material-symbols-outlined align-bottom">download</span>
                </div>
              </div>
              &nbsp;ダウンロード
            </button>
          }
        </div>
      </div>
      @if (searching) {
        <div class="text-center py-3"><span class="fa fa-spinner fa-spin fa-2x"></span></div>
      }
      @if (selectedStudio && !searching && filteredItems.length === 0) {
        <span>該当するデータはありません</span>
      }
      @if (filteredItems.length > 0) {
        <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pager>
        <table class="table table-bordered table-sm table-hover table-ptb-0">
          <thead>
            <tr>
              <th width="10%">会員ID</th>
              <th width="10%">店舗名</th>
              <th width="20%">会員氏名(かな)</th>
              <th width="20%">除名理由</th>
            </tr>
          </thead>
          <tbody>
            @for (item of pagedItems; track item.id) {
              <tr>
                <td>{{ item.memberCode }}</td>
                <td>{{ item.studio?.name }}</td>
                <td>
                  <a href="" (click)="$event.preventDefault(); openDetailModal(item)">
                    {{ item.lastName }}&nbsp;{{ item.firstName }}&#040;{{ item.lastNameKana }}&nbsp;{{ item.firstNameKana }}&#041;
                  </a>
                </td>
                <td>{{ item.expulsionReason }}</td>
              </tr>
            }
          </tbody>
        </table>
        <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pager>
      }
    </div>
  </div>
</div>
@if (showDetailModal) {
  <div class="modal-backdrop fade show" (click)="showDetailModal = false"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">会員情報 / 詳細</h5>
        </div>
        <div class="modal-body">
          <table class="table table-sm table-borderless">
            <tr><th class="text-right" style="width:40%;">会員ID：</th><td>{{ selectedMember?.memberCode }}</td></tr>
            <tr><th class="text-right">会員氏名（かな）：</th><td>{{ selectedMember?.lastName }} {{ selectedMember?.firstName }}({{ selectedMember?.lastNameKana }} {{ selectedMember?.firstNameKana }})</td></tr>
            <tr><th class="text-right">生年月日：</th><td>{{ selectedMember?.birthday }}</td></tr>
            <tr><th class="text-right">住所：</th><td>〒{{ selectedMember?.zip }}</td></tr>
            <tr><th class="text-right"></th><td>{{ selectedMember?.province }}&nbsp;{{ selectedMember?.city }}</td></tr>
            <tr><th class="text-right"></th><td>{{ selectedMember?.area }}&nbsp;{{ selectedMember?.address }}</td></tr>
            <tr><th class="text-right">電話番号：</th><td>{{ selectedMember?.phone }}</td></tr>
            <tr><th class="text-right">メールアドレス：</th><td>{{ selectedMember?.email }}</td></tr>
            <tr><th class="text-right">コース区分：</th><td>{{ selectedMember?.studioPlan?.name }}</td></tr>
            <tr><th class="text-right">支払方法：</th>
              <td>
                @if (selectedMember?.payment?.paymentMethod === 0) { <span>口座振替</span> }
                @if (selectedMember?.payment?.paymentMethod === 1) { <span>クレジット</span> }
              </td>
            </tr>
            <tr><th class="text-right">入退館キー：</th><td>{{ selectedMember?.keyNumber?.keyNumber }}</td></tr>
            <tr><th class="text-right">ロッカー：</th><td>{{ selectedMember?.lockerNumber?.lockerNumber }}</td></tr>
            <tr><th class="text-right">登録日時：</th><td>{{ selectedMember?.createdAt | date: 'yyyy/MM/dd HH:mm' }}</td></tr>
          </table>
        </div>
        <div class="modal-footer">
          <button class="btn bg-close text-white" type="button" (click)="showDetailModal = false">
            <i class="fa s-icon-cancel"></i>&nbsp;閉じる
          </button>
        </div>
      </div>
    </div>
  </div>
}
@if (showDownloadModal) {
  <div class="modal-backdrop fade show"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">除名者データダウンロード</h5>
          <button type="button" class="close" (click)="showDownloadModal = false">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          データベースに保存されている、該当店舗のすべての除名者データをダウンロードします。ダウンロードされたデータには除名者の個人情報が含まれます。<br />
          よろしいですか。
        </div>
        <div class="modal-footer">
          <button class="btn bg-close text-white" type="button" (click)="showDownloadModal = false">
            <i class="fa s-icon-cancel"></i>&nbsp;閉じる
          </button>
          <button class="btn btn-success" type="button" (click)="doDownloadCsv()" [disabled]="disableDownload">
            <i class="fa s-icon-dawnload"></i>&nbsp;はい
          </button>
        </div>
      </div>
    </div>
  </div>
}
  `
})
export class ExpelledListComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private authState = inject(AuthStateService);
  private studioService = inject(StudioService);
  private studioSelection = inject(StudioSelectionService);

  get userPermission(): number { return this.authState.currentUser?.role ?? 99; }

  studios: any[] = [];
  selectedStudio: any = null;
  allItems: any[] = [];
  keyword = '';
  searching = false;
  private memberLoadId = 0;
  dateFrom = DEFAULT_DATE_FROM;
  dateTo = todayJstString();
  readonly pageLimit = 300;
  pageIndex = 0;
  showDetailModal = false;
  selectedMember: any = null;
  showDownloadModal = false;
  disableDownload = true;
  private csvMembers: any[] = [];
  private csvRequestId = 0;

  get filteredItems(): any[] {
    let list = this.allItems.filter(m => m.status === 2);
    // 除名日は expelledAt。旧版 expelled.js:64-66 の dateFilter も expelledAt を見ている。
    // APIの会員データに updatedAt は存在しないため、これを条件にすると常に0件になる
    list = list.filter(m => isWithinJstDateRange(m.expelledAt, this.dateFrom, this.dateTo));
    list = list.filter(item => matchesNestedKeyword(item, this.keyword));
    return list;
  }

  get pagedItems(): any[] {
    return this.filteredItems.slice(this.pageIndex * this.pageLimit, (this.pageIndex + 1) * this.pageLimit);
  }

  get totalPages(): number {
    return Math.ceil(this.filteredItems.length / this.pageLimit);
  }

  goToPage(p: number): void {
    this.pageIndex = Math.max(0, Math.min(p, this.totalPages - 1));
  }

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('会員管理', 's-icon-members');
    this.studios = await this.studioService.list('all') ?? [];
    const restored = this.studioSelection.restore(this.studios, SESSION_KEY);
    if (restored) {
      this.selectedStudio = restored;
      await this.loadMembers();
    }
  }

  async onStudioChange(): Promise<void> {
    this.allItems = [];
    this.pageIndex = 0;
    if (!this.selectedStudio) { this.studioSelection.clear(SESSION_KEY); return; }
    this.studioSelection.save(this.selectedStudio, SESSION_KEY);
    await this.loadMembers();
  }

  private async loadMembers(): Promise<void> {
    if (!this.selectedStudio) return;
    const loadId = ++this.memberLoadId;
    this.searching = true;
    try {
      const items = await this.studioService.getMember(this.selectedStudio.id) ?? [];
      // 後から選んだ店舗の結果だけを表示する
      if (loadId === this.memberLoadId) this.allItems = items;
    } finally {
      if (loadId === this.memberLoadId) this.searching = false;
    }
  }

  openDetailModal(member: any): void {
    this.selectedMember = member;
    this.showDetailModal = true;
  }

  clearFilter(): void {
    // 旧版 expelled.js:150-158 と同じく除名日は初期値へ戻す（店舗選択は維持）
    this.pageIndex = 0;
    this.keyword = '';
    this.dateFrom = DEFAULT_DATE_FROM;
    this.dateTo = todayJstString();
  }

  // 旧版 expelled.js:273-284: 押下時に /studio/{id}/member/detail を取得し、準備完了まで「はい」を無効にする
  async openDownloadModal(): Promise<void> {
    this.showDownloadModal = true;
    this.disableDownload = true;
    this.csvMembers = [];
    const studioId = this.selectedStudio?.id;
    if (!studioId) return;
    const requestId = ++this.csvRequestId;
    try {
      const data: any = await this.studioService.getMemberDetail(studioId);
      if (requestId !== this.csvRequestId) return;
      this.csvMembers = (Array.isArray(data) ? data : []).filter((m: any) => m.status === 2);
      this.disableDownload = false;
    } catch {
      // 失敗時は ApiService が /error へ遷移する
    }
  }

  doDownloadCsv(): void {
    if (this.disableDownload) return;
    this.showDownloadModal = false;
    // 一覧API(/member)には性別・国籍・入会方法・ロッカー・更新日が含まれないため、詳細APIの結果を使う
    const data = this.csvMembers;
    const headers = [
      '店舗', '区分コース', '入会方法', 'ステータス', '入退館キー番号',
      '会員ID', '氏名', '氏名(かな)', '住所', '電話番号', 'メールアドレス',
      '生年月日', '性別', '国籍', '支払方法', 'ロッカー使用状況',
      'ロッカー番号', 'ロッカープラン', '会員登録日', '最終更新日', '除名理由', '除名日',
    ];
    const fmt = (d: string) => {
      const dt = new JstDate(d);
      if (isNaN(dt.getTime())) return '';
      return `${dt.getFullYear()}/${String(dt.getMonth() + 1).padStart(2, '0')}/${String(dt.getDate()).padStart(2, '0')}`;
    };
    const rows = data.map(m => {
      const plan = !m.studioPlan ? (m.studioPlanId === 999999999 ? '見学予約' : '-') : m.studioPlan.name;
      const statusMap: Record<number, string> = { 0: '在籍中', 1: '停止', 2: '停止(除名)', 3: '削除済', 4: '仮登録', 5: '来館アンケート回答' };
      const useLocker = m.isUseLocker === 0;
      return [
        m.studio?.name ?? '',
        plan,
        m.isWebRegister === 1 ? '店舗入会' : 'Web入会',
        statusMap[m.status] ?? '',
        m.keyNumber?.keyNumber ?? '',
        m.memberCode ?? '',
        `${m.lastName ?? ''} ${m.firstName ?? ''}`,
        `${m.lastNameKana ?? ''} ${m.firstNameKana ?? ''}`,
        `〒${m.zip ?? ''} ${m.province ?? ''} ${m.city ?? ''} ${m.area ?? ''} ${m.address ?? ''}`,
        m.phone ?? '',
        m.email ?? '',
        m.birthday ?? '',
        m.sex === 1 ? '女性' : '男性',
        m.isJapanese === 1 ? '日本以外' : '日本',
        !m.payment ? '未登録' : (m.payment.paymentMethod === 0 ? '口座振替' : 'クレジットカード'),
        useLocker ? '使用中' : '使用していない',
        useLocker ? (m.lockerNumber?.lockerNumber ?? '') : '',
        useLocker ? (m.lockerNumber?.product?.name ?? '') : '',
        fmt(m.createdAt),
        fmt(m.updatedAt),
        m.expulsionReason ?? '',
        fmt(m.expelledAt),
      ];
    });
    const escape = (v: any) => `"${String(v ?? '').replace(/"/g, '""')}"`;
    const csv = '﻿' + [headers, ...rows].map(r => r.map(escape).join(',')).join('\r\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${serverTime.now()}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  }
}
